import { useFormik } from "formik";
import InputText from "global/InputText/InputText";
import Modal from "global/Modal/Modal";
import SimpleButton from "global/SimpleButton/SimpleButton";
import { OTPMobile } from "global/Validation/Validation";
import { useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { setOTPMobile } from "redux/otp";

function VerificationModal({ open, setOpen, mobile, sendOTP, hasEdit }) {
  const [edit, setEdit] = useState(false);
  const dispatch = useDispatch();
  const { values, errors, handleChange, handleSubmit, touched } = useFormik({
    validationSchema: OTPMobile,
    initialValues: {
      mobile: mobile,
    },
    onSubmit: () => {
      sendOTP(values.mobile);
      dispatch(setOTPMobile(values.mobile));
    },
  });
  return (
    <>
      <Modal visible={open} setVisible={setOpen} title="ارسال کد اعتبارسنجی">
        <div className="px-20">
    
          <div className=" flex items-center pt-8 pb-10  text-lg text-right">
            کد تایید به شماره{" "}
            {
              <>
                {!edit ? (
                  <div className=" flex gap-2 mx-2">
                    {values.mobile}
                    {hasEdit && (
                      <button onClick={() => setEdit(true)}>
                        <AiOutlineEdit />
                      </button>
                    )}
                  </div>
                ) : (
                  <div className=" flex mx-2 gap-1 items-center">
                    <InputText
                      wrapperClassName="w-[8rem] mt-4   "
                      values={values.mobile}
                      name="mobile"
                      handleChange={handleChange}
                      error={touched.mobile && errors.mobile}
                    />
                    <button onClick={() => setEdit(false)}>x</button>
                  </div>
                )}
              </>
            }{" "}
            ارسال شود؟
          </div>
        </div>

        <div className="btnForm">
          <SimpleButton
            handelClick={() =>
              setOpen((prev) => ({ ...prev, verificationModal: false }))
            }
            text="لغو"
            className="text-tomato "
          />
          <SimpleButton
            handelClick={handleSubmit}
            type="button"
            text="ارسال کد"
            className="full-tomato-btn"
          />
        </div>
      </Modal>
    </>
  );
}

export default VerificationModal;
